import i18n from "../../i18n";
import axios from "axios";
const actions = {
  getUsersData(context) {
    return axios
      .get("user")
      .then(function (r) {
        return r.data.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
        return [];
      });
  },
  getUsers(context) {
    context.commit("SET_ALL_USERS");
    axios
      .get("user")
      .then(function (response) {
        context.commit("SET_ALL_USERS", response.data.data);
      })
      .catch(function (e) {
        context.commit("SET_ALL_USERS", e);
        context.dispatch("triggerError", e);
      });
  },
  createUser(context, value) {
    return axios
      .post("user", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("snackbars.userAdded", { name: r.data.name })
        );
        return r.data;
      })
      .catch(function (e) {
        if (e.response.data.message === "User with email already exists") {
          context.dispatch("triggerUniversalAlert", {
            text: i18n.t("snackbars.emailNotAvailableText"),
            heading: i18n.t("snackbars.emailAlreadyUsedHeading"),
            type: "warning",
          });
        } else {
          context.dispatch("triggerError", e);
        }
      });
  },

  deleteUser(context, val) {
    return axios
      .delete("user/" + val.id)
      .then(function (res) {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.userDeleted"));
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateUser(context, value) {
    return axios
      .put("user/" + value.id, value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("snackbars.userChanged", { name: r.data.name })
        );
        return r.data;
      })
      .catch(function (e) {
        if (e.response.data.message === "User with email already exists") {
          context.dispatch("triggerUniversalAlert", {
            text: i18n.t("snackbars.emailNotAvailableText"),
            heading: i18n.t("snackbars.emailAlreadyUsedHeading"),
            type: "warning",
          });
        } else {
          context.dispatch("triggerError", e);
        }
      });
  },

  updateUserPassword(context, value) {
    return axios
      .put("user/my/password", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("snackbars.ownPasswordChanged")
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getAccessRoles(context) {
    return axios
      .get("user/accessRoles")
      .then((r) => (r.data && r.data.roles) || [])
      .catch(function (e) {
        context.dispatch("triggerError", e);
        return [];
      });
  },
  getSingleUser(context, id) {
    return axios
      .get("user/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
